// apiSlice.ts
import { FetchBaseQueryError, createApi } from '@reduxjs/toolkit/query/react'
//import { Point } from '../components/carecenter/Centers'
import { baseQueryWithReauth } from './ChatSlice'
import { createHandleQueryErrorAndRetry, } from '../app/rtkQueryErrorHandler'
import { RootState } from '../app/store'

// export interface profileCreateMatch {
//     iamId: string | null,
//     userName: string | null,
//     email: string | null,
//     nickname: string | null
//     isFederated: boolean | null
// } 




export interface profileCreateMatch {
    iamId: string | undefined | null,
    email: string | undefined | null,
    phone: string | undefined | null,
    nickname: string | undefined | null
    isFederated: boolean | null
    sms_consent: boolean | undefined | null
}
export const ProfileTagTypes = ['Profile', 'ChatUserProfile', 'ProfilePinData', 'Username', 'NonUserProfile']
export const profileApi = createApi({
    reducerPath: 'profileApi',
    //baseQuery: fetchBaseQuery(),
    baseQuery: baseQueryWithReauth,
    tagTypes: ProfileTagTypes,
    endpoints: (builder) => ({
        //gest profile  by iam_is inserts if no matching profile found    
        getEmailConfirmationStatus: builder.query<any, string>({
            query: (email) => {
                const qry = `/api/get/emailConfirmationStatus/?email=${email}`
                return qry
            },
        }),
        getLoggedInUserProfile: builder.query<any, profileCreateMatch>({
            query: (args) => {
                const path = `/api/get/userProfile/`;
                const iamId = args.iamId ? args.iamId : "unauthenticated"
                const params = {
                    iamId: iamId,
                    email: args.email,
                    nickname: args.nickname,
                    is_federated: args.isFederated,
                    phone: args.phone,
                    sms_consent: args.sms_consent
                };
                //const qry = `/api/get/userProfile/?iamId=${iamId}&email=${args.email??''}&nickname=${args.nickname}&is_federated=${args.isFederated}&phone=${args.phone??''}`
                //return qry
                return {
                    url: path,
                    params: params
                };
            },
            onQueryStarted: (arg, api) => {
                // Create the handler instance with RootState (inferred at this point)
                const handler = createHandleQueryErrorAndRetry<RootState>(
                    'getLoggedInUserProfile',
                    profileApi.endpoints.getLoggedInUserProfile.initiate, // <--- Pass the specific initiate function here!
                    (rawError) => {
                        if (!(rawError as any)?.error?.data) {
                            return true
                        }
                        const data = (rawError as any)?.error?.data as string; //rawError.error.data.error
                        const mustLogOutFound = data.includes('Must log out')
                        if (typeof data === "string" && ( mustLogOutFound || data.includes("unique") || data.includes('not found in authentication system'))) {
                            return false;
                        }
                        return true
                    }
                );
                // Execute the handler
                handler(arg, api);
            },
            providesTags: (result, response, updated) => {
                return [{ type: 'Profile', id: result?.id ?? '' }]
            }
        }),
        // getProfilesNearUser: builder.query<any[], number>({
        //     query: (profileId) => `/api/get/profilesNearUser/?radius=160934&profileId=${profileId}`,//refactorlat=${args.lat}&lng=${args.lng}&
        //     providesTags: (result) => {
        //         if (result) {
        //             return [//...result.map((row) => (                        { type: 'Profile' as const, id: row.id })), 
        //                 { type: 'ProfilePinData', id: 'LIST' }]
        //         }
        //         return [{ type: 'ProfilePinData' as const, id: 'LIST' }]
        //     }
        // }),
        getProfilesForPoint: builder.query<any[], {lng:number, lat:number}>({
            query: ({lng, lat}) => `/api/get/profilesForPoint/?radius=160934&lat=${lat}&lng=${lng}`,
            providesTags: (result) => {
                if (result) {
                    return [//...result.map((row) => (                        { type: 'Profile' as const, id: row.id })), 
                        { type: 'ProfilePinData', id: 'FOR_USER' }]
                }
                return [{ type: 'ProfilePinData' as const, id: 'FOR_USER' }]
            }
        }),
        getProfilesPinDataForDefaultPoint: builder.query<any[], void>({
            query: () => `/api/get/profilespindatafordefaultpoint/?radiusNumber=160934`,//refactorlat=${args.lat}&lng=${args.lng}&
            providesTags: (result) => {
                if (result) {
                    return [//...result.map((row) => (                        { type: 'Profile' as const, id: row.id })), 
                        { type: 'ProfilePinData', id: 'LIST' }]
                }
                return [{ type: 'ProfilePinData' as const, id: 'LIST' }]
            }
        }),
        getAcceptanceStatus: builder.query<any[], string>({
            query: (identifier) => {
                const params = new URLSearchParams({ 'identifier' : identifier });                                            
                 return `/api/get/acceptance/?${params.toString()}`
            }
            // providesTags: (result) => {
            //     if (result) {
            //         return [//...result.map((row) => (                        { type: 'Profile' as const, id: row.id })), 
            //             { type: 'ProfilePinData', id: 'LIST' }]
            //     }
            //     return [{ type: 'ProfilePinData' as const, id: 'LIST' }]
            // }
        }),
        getProfilesPinData: builder.query<any[], void>({
            query: (args: any) => `/api/get/profilespindata`,
            providesTags: (result) => {
                return [{ type: 'ProfilePinData' as const, id: 'LIST' }]
            }
        }),
        getProfile: builder.query<any, number>({
            query: (id) => {
                const qry = `/api/get/profile/${id}`
                return qry
            },
            providesTags: (result, response, id) => {
                return [{ type: 'ChatUserProfile', id: id }]
            }
        }),
        getProfileByPhone: builder.query<any, string>({
            query: (phone) => {
                const qry = `/api/get/profileByPhone/?phone=${phone}`
                return qry
            },
            providesTags: (result, response, phone) => {
                return [{ type: 'Profile', id: `phone-${phone}` }]
            }
        }),
        UpdateProfile: builder.mutation<any, { id: number | null, profileDTO: any /*& Pick<any, | 'lat' | 'lng'>*/ }>({
            query: ({ id, profileDTO: profile2Update }) => ({
                url: `/api/update/userProfile/${id}`,
                method: 'PATCH',
                body: profile2Update,
            }),
            invalidatesTags: (result, response, updated) => [
                //{ type: 'Profile', id: updated.id ? updated.id : "not invalidating unauthorized"},
                //{ type: 'Profile', id: updated.id ? updated.id : "not invalidating unauthorized" },
            ]
        }),

        UpdateProfileGroup: builder.mutation<any, { id: number | null, groupObject: any /*& Pick<any, | 'lat' | 'lng'>*/ }>({
            query: ({ id, groupObject }) => ({
                url: `/api/update/userProfileGroup/${id}`,
                method: 'PATCH',
                body: groupObject,
            }),
            invalidatesTags: (result, response, updated) => [
                { type: 'Profile', id: updated?.id ?? '' }
                //{ type: 'Profile', id: updated.id ? updated.id : "not invalidating unauthorized"},
                //{ type: 'Profile', id: updated.id ? updated.id : "not invalidating unauthorized" },
            ]
        }),


        DeleteUserData: builder.mutation<void, { id: number, userName: string }>({
            query: ({ id, userName }) => {
                return ({
                    url: `/api/DeleteUserData/?id=${id}&userName=${userName}`,
                    method: 'DELETE',
                })
            },
            //invalidatesTags: (result, response, updated) => [{ type: 'Profile', id: updated }]
        }),
        UpdateUsername: builder.mutation<any, { id: number, username: string /*& Pick<any, | 'lat' | 'lng'>*/ }>({
            query: ({ id, username }) => ({
                url: `/api/update/username/${id}`,
                method: 'PATCH',
                body: { username: username },
            }),
            invalidatesTags: ['Username'], // Invalidate the tag on mutation 
        }),
        addNonUserProfile: builder.mutation<any, { profilePTO: any }>({
            query: ({ profilePTO }) => ({
                url: '/api/post/addNonUserProfile',
                method: 'POST',
                body: profilePTO,
            }),
            // Consider invalidating relevant tags if needed, e.g., a list of non-user profiles
            // invalidatesTags: [{ type: 'NonUserProfile', id: 'LIST' }],
        }),
        mergeInstitutionLeaders: builder.mutation<any, { source_id: number, target_id: number }>({
            query: ({ source_id, target_id }) => ({
                url: '/api/merge-institution-leaders',
                method: 'POST',
                body: { source_id, target_id },
            }),
            invalidatesTags: (result, error, args) => [
                { type: 'Profile', id: args.source_id },
                { type: 'Profile', id: args.target_id },
            ],
        }),
    }),
})




export const { useGetProfileQuery, useGetProfileByPhoneQuery, useGetProfilesPinDataQuery,
    //useGetUserProfileByNameQuery,
    useGetLoggedInUserProfileQuery,
    //    useGetLoggedInUserProfile1Query,
    //useGetProfilesForPointQuery,
    useGetProfilesPinDataForDefaultPointQuery,
    // useDeleteProfileMutation,
    useUpdateProfileMutation, useDeleteUserDataMutation, useUpdateUsernameMutation,
    useGetEmailConfirmationStatusQuery, useUpdateProfileGroupMutation,
    useAddNonUserProfileMutation, useMergeInstitutionLeadersMutation, //useGetProfilesNearUserQuery
    useGetProfilesForPointQuery
} = profileApi


export function isFetchBaseQueryError(
    error: unknown
): error is FetchBaseQueryError {
    return typeof error === 'object' && error !== null && 'status' in error
}
/**
 * Type predicate to narrow an unknown error to an object with a string 'message' property
 */
export function isErrorWithMessage(
    error: unknown
): error is { message: string } {
    return (
        typeof error === 'object' &&
        error !== null &&
        'message' in error &&
        typeof (error as any).message === 'string'
    )
}
